import {Flow} from '../../../shared/models/state/Flow';
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {NodeObject, NodeTypes} from '../../../shared/utils/nodeTypes';
import {RolesService} from "../../services/roles/roles.service";

export const selectorFlow = createFeatureSelector<Flow>('flow');

export const selectFlow = createSelector(
    selectorFlow,
    (flow: Flow) => flow
);

// TODO [JF-2022/06/08]: look into how the selector is use
export const selectFlowModeState = createSelector(
    selectorFlow,
    (flow: Flow) => flow.flowModeState
);

export const selectFlowMetaData = createSelector(
    selectFlow,
    (flow: Flow) => flow.flowMetaData
);

export const selectNodeTypes = createSelector(
    selectFlow,
    (flow: Flow) => flow.nodeTypes
);

export const selectNodeTypesMap = createSelector(
    selectNodeTypes,
    (nodeTypes: NodeTypes) => {
        const nodeObjectMap = {};
        const nodeTypesList = [].concat(
            nodeTypes.chathubNodes,
            nodeTypes.startNodes,
            nodeTypes.actionNodes,
            nodeTypes.integrationsNodes.VENDOR,
            nodeTypes.integrationsNodes.FUNDING_SOURCE,
            nodeTypes.integrationsNodes.default,
            nodeTypes.menuNodes);
        for (const item of nodeTypesList) {
            switch (item.nodeType) {
                case 'chatHub':
                    if (item.extraFields?.providerId) {
                        nodeObjectMap[item.extraFields.providerId] = item;
                    } else {
                        nodeObjectMap[item.nodeType] = item;
                    }
                    break;
                default:
                    nodeObjectMap[item.nodeType] = item;
                    break;
            }
        }
        return nodeObjectMap;
    }
);

export const selectMenuNodeTypes = createSelector(
    selectFlow,
    (flow: Flow) => flow.nodeTypes.menuNodes.filter(nodeObject => filterNodePermissions(nodeObject, flow.permissions))
);

export const selectActionNodeTypes = createSelector(
    selectFlow,
    (flow: Flow) => flow.nodeTypes.actionNodes.filter(nodeObject => filterNodePermissions(nodeObject, flow.permissions))
);

// TODO build filter for IntegrationsNode
export const selectIntegrationsNodeTypes = createSelector(
    selectFlow,
    (flow: Flow) => flow.nodeTypes.integrationsNodes
);

export const selectStartNodesNodeTypes = createSelector(
    selectFlow,
    (flow: Flow) => flow.nodeTypes.startNodes.filter(nodeObject => filterNodePermissions(nodeObject, flow.permissions))
);

export const selectChatHubNodesTypes = createSelector(
    selectFlow,
    (flow: Flow) => flow.nodeTypes.chathubNodes.filter(nodeObject => filterNodePermissions(nodeObject, flow.permissions))
);

const filterNodePermissions = (nodeObject: NodeObject, userRoles: {}): boolean => {
    if (nodeObject.permissions && nodeObject.permissions.canEdit) {
        return RolesService.isUserRoles(userRoles, nodeObject.permissions.canEdit)
    }
    return true;
}